'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voting-edit', {
      url: '/voting/edit/:id',
      template: '<voting-edit></voting-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voting/voting-edit/voting-edit.routes.js